export const CLIENT_PRIVACY_FIELDS = [
  { value: "names", label: "Names", description: "Primary client and household member names" },
  { value: "phone", label: "Phone numbers" },
  { value: "email", label: "Email addresses" },
  { value: "address", label: "Addresses", description: "Street, unit, city, state, and ZIP" },
];

export function hiddenClientFields(user) {
  return Array.isArray(user?.hidden_client_fields) ? user.hidden_client_fields : [];
}

export function hasClientPrivacy(user) {
  return hiddenClientFields(user).length > 0;
}

export function privacyLabels(user) {
  return CLIENT_PRIVACY_FIELDS.filter(({ value }) => hiddenClientFields(user).includes(value))
    .map(({ label }) => label);
}
